import { ALL_PRODUCTS_PREFIX } from 'swag-common/constants/main-swag.constants';
export function getIsAllProductsPage(pathname = '') {
  return pathname.endsWith(ALL_PRODUCTS_PREFIX);
}
export function generateTitleForAllProductsPage(categoryName = '') {
  return `Promo ${categoryName} – Buy Custom Products With Logo & Brand – Swag.com`;
}